import React, { useState } from "react";
import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table/interface";
import { PaginationProps } from "antd/es/pagination";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, mianCode } from "@/utils/constants";
import { IPgProps, ISearchPage } from "@/types/ScmTypes";
import { globalPrompt } from "@/components/message";
import { useDictModel } from "../dict/dictModel";
import { warehouseService, IWarehouseFileds, IWarehouseSearch, IWarehouseDetail, IShelfFileds, IShelfInsert, IShelfSearch, IShelfBatchInsert } from "./warehouseService";
import { DictCodeEnmu, sourceAppOrBranch, orgCodeOrName } from "@/types/VrmSaDictEnums"
import { useGlobalModel } from "@/model/globalModel";
import { itemService } from "../item/itemService";
import { transPgToPagination } from "@/utils/utils";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";

export interface ISCMTabsDrawerInfo {
    visible: boolean,
    mode: "add" | "edit"
}

export enum ISCMWarehouseTabEnmu {
    Area = "区域",
    Shelves = "货架",
    Shelf = "货位"
}

export const useWarehouseModel = createModel(function () {
    const { user, setShelfList,setLocale } = useGlobalModel();
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const Locale = setLocale(LanguageArr)
    const { getTreeNodeName } = useDictModel();
    /**
     * 仓库列表
     */
    //列表数据源
    const [dataSource, setDataSource] = useState<IWarehouseDetail[]>([]);
    //查询条件
    const [searchParam, setSearchParam] = useState<IWarehouseSearch>({});
    //分页参数
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    //行选id
    const [selectedRowKeys, setSelectedRowKeys] = useState<string>("");
    //仓库列表查询
    const loadData = async (page?: ISearchPage, searchValue: IWarehouseSearch = searchParam) => {
        const searchParams = {
            ...searchValue,
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.pageNum || page?.current) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        let { retData } = await warehouseService.page(searchParams);
        const { records, ...pg } = retData;
        setPgCfg(transPgToPagination(pg));
        setDataSource(records);
    }
    //设置搜索value
    const updateSearchParam = (updateParam: IWarehouseSearch) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }
    //重置搜索参数
    const resetSearchParam = () => {
        setSearchParam({});
        setSelectedRowKeys("");
        loadData(initPgCfg, {});
    }
    const onDisabled = async (id: string, checked: boolean) => {
        let { retData } = await warehouseService.disable({ id, enable: checked ? 1 : 0 })
        retData ?
            // loadData() && globalPrompt("message", { text: "仓库编辑成功", type: "success" })
            // : globalPrompt("message", { text: "仓库编辑失败", type: "error" });
            loadData() && globalPrompt("message", { text: Locale["Successfully edited"], type: "success" })
            : globalPrompt("message", { text: Locale["Unsuccessfully edited"], type: "error" });
        return retData;
    }
    /**
     * 仓库新增
     */
    const [addWareVisible, setAddWaerVisible] = useState<boolean>(false);

    //仓库新增 Api
    const insertWarehouse = async (data: IWarehouseFileds) => {
        let params = {
            ...data,
            // ...sourceAppOrBranch,
            sourceApp: mianCode,
            branch: mianCode,
            ...orgCodeOrName,
            typeName: getTreeNodeName(data.typeCode as string)
        }
        let { retData } = await warehouseService.insert(params);
        retData ?
            // loadData() && globalPrompt("message", { text: "仓库新增成功", type: "success" })
            // : globalPrompt("message", { text: "仓库新增失败", type: "error" });
            loadData() && globalPrompt("message", { text: Locale["Successfully added"], type: "success" })
            : globalPrompt("message", { text: Locale["Unsuccessfully added"], type: "error" });            
        return retData;
    }

    /** 
     * 仓库详情
     */
    const initWaerhouseFormVal = {
        id: "",
        shopId: "",
        shopName: "",
        orgCode: "",
        orgName: "",
        code: "",
        name: "",
        contact: "",
        phone: "",
        address: "",
        note: "",
        createTime: "",
        updateTime: "",
        createUser: "",
        updateUser: "",
    }
    //编辑表单缓存
    const [editFormVal, setEditFormVal] = useState<IWarehouseDetail>(initWaerhouseFormVal);

    //表单修改
    const updateEditFormVal = (val: IWarehouseDetail | null) => {
        setEditFormVal(val ? { ...editFormVal, ...val } : initWaerhouseFormVal);
    }

    //获取一条详情数据 Api
    const getWarehouseOne = async (id: string) => {
        let { retData } = await warehouseService.one(id);
        retData && setEditFormVal(retData);
    }

    //表单编辑 Api
    const editWarehouse = async (data: IWarehouseDetail) => {
        let { retData } = await warehouseService.update({ 
            ...data,
            //  ...sourceAppOrBranch 
            sourceApp: mianCode,
            branch: mianCode,
            });
        retData ?
            // loadData() && globalPrompt("message", { text: "仓库编辑成功", type: "success" })
            // : globalPrompt("message", { text: "仓库编辑失败", type: "error" });
            loadData() && globalPrompt("message", { text: Locale["Successfully edited"], type: "success" })
            : globalPrompt("message", { text: Locale["Unsuccessfully edited"], type: "error" });
        return retData;
    }
    //货位    
    const initShelfDrawer: ISCMTabsDrawerInfo = { visible: false, mode: "add" };
    const [shelfPgCfg, setShelfPgCfg] = useState<TablePaginationConfig>(initPgCfg);  //分页参数
    const [shelfDataSource, setShelfDataSource] = useState<IShelfFileds[]>([]); //区域数据源
    const [selectedShelfRows, setSelectedShelfRows] = useState<IShelfFileds[]>([]); //多选Shelf行信息
    const [shelfDrawer, setShelfDrawer] = useState<boolean>(false);
    //货位列表 Api
    const shelfLoadData = async (warehouseId: string, page?: ISearchPage,) => {
        const searchParams = {
            warehouseId,
            pageSize: page?.pageSize ?? shelfPgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.pageNum || page?.current) ?? shelfPgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        let { retData } = await warehouseService.shelfPage(searchParams);
        const { records, ...pg } = retData;
        setShelfPgCfg(transPgToPagination(pg));
        setShelfDataSource(records);
        shelfLoadAllData()
    }
    //加载所有货位
    const shelfLoadAllData = async () => {
        const searchParams = {
            pageSize: 9999,
            pageNum: 1,
        }
        let { retData } = await warehouseService.shelfPage(searchParams);
        const { records, ...pg } = retData;
        const newRecords = records.map(item => { return { ...item, name: item.code } })
        setShelfList(newRecords);
    }
    //货位新增
    const insertShelf = async (params: IShelfInsert) => {
        let data = {
            ...params,
            warehouseId: editFormVal.id,
            warehouseCode: editFormVal.code,
            shelvesId: "",
            shelvesCode: "",
            areaId: "",
            areaCode: "",
        }
        let { retData } = await warehouseService.shelfInsert(data);
        // retData ? shelfLoadData(editFormVal.id as string) && globalPrompt("message", { text: "货位新增成功", type: "success" }) : globalPrompt("message", { text: "货位新增失败", type: "success" });
        retData ? shelfLoadData(editFormVal.id as string) && globalPrompt("message", { text: Locale["New shelf has been successfully added."], type: "success" }) : globalPrompt("message", { text: Locale["New shelf has been unsuccessfully added."], type: "success" });


    }
    //货位批量新增
    const insertBatchShelf = async (params: IShelfBatchInsert) => {
        let data = {
            ...params,
            warehouseId: editFormVal.id,
            warehouseCode: editFormVal.code,
            shelvesId: "",
            shelvesCode: "",
            areaId: "",
            code: "",
            areaCode: "",
        }
        let { retData } = await warehouseService.shelfBatchInsert(data);
        // retData ? shelfLoadData(editFormVal.id as string) && globalPrompt("message", { text: "货位新增成功", type: "success" }) : globalPrompt("message", { text: "货位新增失败", type: "success" });
        retData ? shelfLoadData(editFormVal.id as string) && globalPrompt("message", { text: Locale["New shelf has been successfully added."], type: "success" }) : globalPrompt("message", { text: Locale["New shelf has been unsuccessfully added."], type: "success" });

    }

    return {
        /***field***/
        searchParam,
        dataSource,
        selectedRowKeys,
        pgCfg,
        editFormVal,
        addWareVisible,
        shelfPgCfg,
        shelfDataSource,
        selectedShelfRows,
        shelfDrawer,
        // tabsFlag,
        // shelfDataSource,
        // shelfPgCfg,
        // selectedShelfRows,
        /***method***/
        setAddWaerVisible,
        updateEditFormVal,
        insertWarehouse,
        editWarehouse,
        getWarehouseOne,
        setDataSource,
        setSelectedRowKeys,
        loadData,
        updateSearchParam,
        resetSearchParam,
        setShelfPgCfg,
        setShelfDataSource,
        shelfLoadData,
        setSelectedShelfRows,
        setShelfDrawer,
        insertShelf,
        insertBatchShelf,
        shelfLoadAllData,
        onDisabled
    }
});